// extracted by mini-css-extract-plugin
export default {"eventDetailsContent":"EventsDetails_eventDetailsContent__GFB4C","eventInfo":"EventsDetails_eventInfo__Q2Fx0","aboutThisEvent":"EventsDetails_aboutThisEvent__GJzAc"};